/*-----------------------------------------------------------------------------/
/ Beluga Kids – "Mehr Artikel von [vendor]" (sections/section-vendor-list.liquid)
/ Übernommen aus dem alten Theme; Karussell jetzt über items-scroll statt Slick.
/-----------------------------------------------------------------------------*/

function updateVendorListLayout(vendorList, slider) {
  const count = slider.children.length;
  const gridDesktop = parseInt(vendorList.dataset.gridDesktop || '3', 10);
  const gridMobile = parseInt(vendorList.dataset.gridMobile || '1', 10);
  const navigation = vendorList.querySelector('.js-vendor-list-navigation');

  if (navigation) {
    navigation.removeAttribute('items-overflow');
    navigation.removeAttribute('items-overflow-max');

    if (count > gridDesktop) {
      navigation.setAttribute('items-overflow', '');
    } else if (count > gridMobile) {
      navigation.setAttribute('items-overflow-max', 'phab');
    }
  }

  slider.classList.toggle('grid-layout--align-center', gridDesktop > count);
}

class VendorList extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;

    if (this.hasAttribute('on-page-load')) {
      this.loadProducts();
      return;
    }

    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(this);
            this.loadProducts();
          }
        });
      },
      { rootMargin: '0px 0px 400px 0px' },
    ).observe(this);
  }

  loadProducts() {
    if (this.dataset.loaded === 'true') return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const results = html.querySelector('[data-vendor-list-results]');
        const slider = this.querySelector('[data-vendor-list-slider]');

        if (!results || !slider) {
          this.hideSection();
          return;
        }

        const excludeId = this.dataset.excludeProductId;
        if (excludeId) {
          results.querySelectorAll(`[data-product-id="${excludeId}"]`).forEach((card) => card.remove());
        }

        const cards = results.querySelectorAll('product-card');
        if (cards.length === 0) {
          this.hideSection();
          return;
        }

        slider.innerHTML = '';
        cards.forEach((card) => slider.appendChild(card));

        this.dataset.loaded = 'true';
        updateVendorListLayout(this, slider);
        document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      })
      .catch((error) => {
        console.error(error);
        this.hideSection();
      });
  }

  hideSection() {
    const root = this.closest('.shopify-section');
    if (root) root.hidden = true;
  }
}

if (!customElements.get('vendor-list')) {
  customElements.define('vendor-list', VendorList);
}
